import React from 'react';
import { Section, VideoPlayer } from './ui';
export const Result = () => {
  return <Section className="bg-brand-premium text-white" data-id="element-172">
      <div className="text-center mb-10" data-id="element-173">
        <p className="text-sm font-bold tracking-widest text-gray-400 uppercase mb-4" data-id="element-174">
          EL RESULTADO:
        </p>
      </div>

      <div className="max-w-md md:max-w-2xl mx-auto mb-10" data-id="element-175">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-8 text-base sm:text-lg md:text-xl font-medium justify-items-center sm:justify-items-start" data-id="element-176">
          <div className="flex items-center gap-3" data-id="element-177">
            <span className="text-brand-green" data-id="element-178">✅</span> Pasteles húmedos
          </div>
          <div className="flex items-center gap-3" data-id="element-179">
            <span className="text-brand-green" data-id="element-180">✅</span> Esponjosos
          </div>
          <div className="flex items-center gap-3" data-id="element-181">
            <span className="text-brand-green" data-id="element-182">✅</span> Sin gluten
          </div>
          <div className="flex items-center gap-3" data-id="element-183">
            <span className="text-brand-green" data-id="element-184">✅</span> Sin lácteos
          </div>
          <div className="flex items-center gap-3 sm:col-span-2 sm:justify-self-center" data-id="element-185">
            <span className="text-brand-green" data-id="element-186">✅</span> Sin azúcar refinada
          </div>
        </div>
      </div>

      <div className="text-center mb-10" data-id="element-187">
        <p className="text-xl sm:text-2xl md:text-3xl font-bold text-yellow-400 leading-snug" data-id="element-188">
          Y lo mejor: 👉 funciona incluso en tu primer intento
        </p>
      </div>

      <VideoPlayer src="https://i.imgur.com/FQk4Gz1.mp4" data-id="element-189" />
    </Section>;
};